import MojitoCore from 'mojito/core';
import AppSettingsImpl from './app-settings.js';

const { UIControllerView } = MojitoCore.Presentation;

/**
 * A module designed to handle the display of app settings.
 *
 * @class AppSettings
 * @memberof Mojito.Modules
 */

export default UIControllerView('AppSettings', AppSettingsImpl);
